import styled, { css } from 'styled-components'
import { BaseButton } from '../../base'

export type ButtonVariant = 'primary' | 'ghost' | 'bordered' | 'secondary'

export interface StyledButtonProps {
  $variant?: ButtonVariant
  $mt?: number
}

export const StyledButton = styled(BaseButton)<StyledButtonProps>(
  ({ theme, $variant = 'primary', $mt = 0 }) => css`
    width: 100%;
    height: 55px;
    margin-top: ${$mt}px;
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    font-weight: 590;
    font-size: 16px;
    transition:
      background-color 0.2s,
      color 0.2s,
      opacity 0.2s;

    ${() => {
      switch ($variant) {
        case 'primary':
          return css`
            background-color: ${theme.colors.primary};
            box-shadow: 0 0 4px 3px rgba(255, 255, 255, 0.25) inset;
            color: #fff;

            &:disabled {
              background-color: #94a3b8;
              box-shadow: none;
              color: #ccd6e0;
            }
          `
        case 'ghost':
          return css`
            background-color: transparent;
            color: ${theme.colors.primary};
          `
        case 'bordered':
          return css`
            background-color: transparent;
            border: 1px solid #ccd6e0;
            color: ${theme.colors.primary};
          `
        case 'secondary':
          return css`
            background-color: #ccd6e0;
            border: 1.4px solid #e6ebf0;
            color: ${theme.colors.primary};
          `
        default:
          return ''
      }
    }}
  `,
)
